import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from '../../../../../services/account.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CorporateService } from 'src/app/services/corporate.service';


@Component({
  selector: 'app-renew-license-dialog',
  templateUrl: './renew-license-dialog.component.html',
  styleUrls: ['./renew-license-dialog.component.css']
})

export class RenewLicenseDialogComponent implements OnInit {
  api_error = null;
  api_success = null;
  renewLicenseObj: any = {};
  renewLicenseForm: UntypedFormGroup;
  addressForm: UntypedFormGroup;
  btndisabled;
  addressAsInGst;
  formErrors = {
    'duration': '',
    'reason': '',

  };
  ValidationMessages = {

    'duration': {
      'required': 'Days is required',
      'min': ' Minimum required day is 1',
      'max': '  Maximum day can be 365'
    },
    'reason': {
      'required': 'Reason is required'
    }
  };
  type: any;
  post_data: any;
  address: Object;


  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: number,
    private accountService: AccountService,
    private formBuilder: UntypedFormBuilder,
    private corporateService: CorporateService
  ) {
    this.renewLicenseForm = this.formBuilder.group({
      accountId: this.data['accountId'],
      corpId: this.data['corpId'],
      duration: ['', [Validators.required, Validators.min(1), Validators.max(365)]],
      reason: ['', [Validators.required] ],

    });
    
  }

  ngOnInit() {
    this.getAddress();
    this.type = this.data['type'];
  }
  markFormGroupTouched(group: UntypedFormGroup = this.renewLicenseForm) {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      abstractControl.markAsTouched();
      if (abstractControl instanceof UntypedFormGroup) {
        this.markFormGroupTouched(abstractControl);
      }
    });
    this.logValidationErrors();

  }
  getAddress(): any {
    this.accountService.getAddress(this.data['accountId'])
      .subscribe(res => {
        this.address = res;
        this.addressAsInGst = this.address;
      });
  }
  OnSubmit() {
    this.api_error = '';
    this.api_success = '';
    this.logValidationErrors();
    if (this.renewLicenseForm.invalid) {
      this.api_error = 'Please fill all the required fields';
      this.markFormGroupTouched();
    } else {
      console.log('value...........' + this.renewLicenseForm.value);
      // tslint:disable-next-line:triple-equals
      if (this.data['type'] == 'account') {
        this.accountService.renewLicense(this.renewLicenseForm.value)
        .subscribe(res => {
          this.api_success =  'License Renewed Successfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
            }, 2000);
        },
          (error) => {
            this.btndisabled = false;
            this.api_error = error.error;
           }
        );
      // tslint:disable-next-line:triple-equals
      } else if (this.data['type'] == 'corporate') {
        this.corporateService.renewLicense(this.renewLicenseForm.value)
        .subscribe(res => {
          this.api_success =  'License Renewed Successfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
            }, 2000);
        },
          (error) => {
            this.btndisabled = false;
            this.api_error = error.error;
           }
        );
      }
      else if (this.data['type'] == 'addAddress') {
        this.corporateService.renewLicense(this.renewLicenseForm.value)
        .subscribe(res => {
          this.api_success =  'License Renewed Successfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
            }, 2000);
        },
          (error) => {
            this.btndisabled = false;
            this.api_error = error.error;
           }
        );
      }
     
    }

  }
  applyAddress() {
    this.api_error = '';
    this.api_success = '';
    if (this.addressAsInGst === '') {
      this.api_error = 'Please fill address';
      this.markFormGroupTouched();
    } else {
      console.log('value...........' + this.addressAsInGst);
      // tslint:disable-next-line:triple-equals
      // this.post_data = this.addressAsInGst
      const payloadString = JSON.stringify(this.addressAsInGst);
        this.corporateService.addAddress(payloadString, this.data['accountId'])
        .subscribe(res => {
          this.api_success =  'Address Added sucessfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
            }, 2000);
        },
          (error) => {
            this.btndisabled = false;
            this.api_error = error.error;
           }
        );
      }
     
    

  }
  

  logValidationErrors(group: UntypedFormGroup = this.renewLicenseForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.ValidationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof UntypedFormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });


  }
  // licenseRenewal() {
  //   this.api_error = '';
  //   this.renewLicense.accountId = this.data;
  //   this.renewLicense.reason = this.renewLicenseObj.reason;
  //   this.renewLicense.duration = this.renewLicenseObj.days;
  //   this.accountService.renewLicense(this.renewLicense)
  //     .subscribe(

  //       data => {
  //         this.api_success =
  //         setTimeout(() => {
  //           this.dialogRef.close('reloadlist');
  //         }, 2000);
  //       },
  //       (error) => {
  //         this.api_error = error.error;
  //       }
  //     );

  // }

  public closeDialog() {
    this.dialogRef.close();
  }

}
